/**
 * Attendance is one page per surface (`/attendance/<slug>`) rather than one page
 * with a tab bar. `Cameras` + `Settings` are merged into a single Attendance
 * Config page with inner sub-tabs, both gated on `attendance.config`.
 */
export interface AttendanceTab {
  slug: string;
  label: string;
  permission?: string;
}

export const ATTENDANCE_TABS: AttendanceTab[] = [
  { slug: 'presence', label: 'Presence' },
  { slug: 'timeline', label: 'Timeline' },
  { slug: 'employees', label: 'Employees' },
  { slug: 'unknown-faces', label: 'Unknown Faces' },
  { slug: 'payroll', label: 'Payroll' },
  { slug: 'config', label: 'Settings', permission: 'attendance.config' },
];

export const DEFAULT_ATTENDANCE_SLUG = 'presence';

export function attendanceTabBySlug(slug?: string): AttendanceTab | undefined {
  return ATTENDANCE_TABS.find((t) => t.slug === slug);
}
